export default __webpack_public_path__ + "static/media/image-breed.11016c01.png";